import { MAX_SEARCH_SKIP } from '@cs-cms/types';

export const exceedsMaxSearchSkip = (skip: number): boolean => {
  return skip > MAX_SEARCH_SKIP;
};
